import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import Countries from '../../../../FormComponents/Countries'
import ReactMultiSelect from '../../../../FormComponents/ReactMultiSelect'

export default observer(function CountryFilter() {
  const { search } = useContext(SearchContext)

  const countryOptions = useMemo(
    () => Countries.map((country) => ({ label: country.name, value: country.code })),
    []
  )

  const setCountryFilter = (countries) => {
    search.country = countries.map(country => country.value)
    search.selectedCountries = countries
  }

  return (
    <div className="w-full">
      <ReactMultiSelect
        placeholder="Any country"
        name="filter"
        onChange={setCountryFilter}
        options={countryOptions}
        value={search.selectedCountries}
        hasSelectAll={false}
      />
    </div>
  )
})
